module.exports = __webpack_public_path__ + "img/volume-up-fill.8995e196.svg";